import { render, staticRenderFns } from "./consensus.vue?vue&type=template&id=161368dc&scoped=true"
import script from "./consensus.vue?vue&type=script&lang=js"
export * from "./consensus.vue?vue&type=script&lang=js"
import style0 from "./consensus.vue?vue&type=style&index=0&id=161368dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161368dc",
  null
  
)

export default component.exports